import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useContext, useSignal, useComputed$, $, sync$, Slot } from "@builder.io/qwik";
import { TAB_PANEL_ID_PREFIX } from "./tab-panel.qwik.mjs";
import { tabsContextId } from "./tabs-context-id.qwik.mjs";
const TAB_ID_PREFIX = "_tab_";
const HTab = component$(({ selectedClassName, tabId, ...props }) => {
  const contextService = useContext(tabsContextId);
  const elementRefSig = useSignal();
  const fullTabElementId = contextService.tabsPrefix + TAB_ID_PREFIX + tabId;
  const fullPanelElementId = contextService.tabsPrefix + TAB_PANEL_ID_PREFIX + tabId;
  const selectedClassNameSig = useComputed$(() => {
    return selectedClassName || contextService.selectedClassName;
  });
  const isSelectedSig = useComputed$(() => {
    return contextService.selectedTabIdSig.value === tabId;
  });
  const selectIfAutomatic$ = $(() => {
    contextService.selectIfAutomatic$(tabId);
  });
  const classNamesSig = useComputed$(() => [
    // TODO only given class if selected
    isSelectedSig.value && [
      "selected",
      selectedClassNameSig.value
    ]
  ]);
  return /* @__PURE__ */ jsx("button", {
    ...props,
    type: "button",
    role: "tab",
    id: fullTabElementId,
    "aria-controls": fullPanelElementId,
    ref: elementRefSig,
    "aria-disabled": props.disabled,
    "data-state": isSelectedSig.value ? "selected" : "unselected",
    onFocus$: [
      selectIfAutomatic$,
      props.onFocus$
    ],
    onMouseEnter$: [
      selectIfAutomatic$,
      props.onMouseEnter$
    ],
    "aria-selected": isSelectedSig.value,
    tabIndex: isSelectedSig.value ? 0 : -1,
    class: [
      props.class,
      classNamesSig.value
    ],
    onClick$: [
      $(() => contextService.selectTab$(tabId)),
      props.onClick$
    ],
    onKeyDown$: [
      /* KeyCode cannot be used here. */
      sync$((e) => {
        const keys = [
          "Home",
          "End",
          "PageDown",
          "PageUp",
          "ArrowDown",
          "ArrowUp",
          "ArrowLeft",
          "ArrowRight"
        ];
        if (keys.includes(e.key)) {
          e.preventDefault();
        }
      }),
      $((e) => contextService.onTabKeyDown$(e.key, tabId)),
      props.onKeyDown$
    ],
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HTab,
  TAB_ID_PREFIX
};
